import {default as formatDate} from './formatDate';

export default {formatDate};
